type TertiaryButtonProps = {
  testLocator?: string
  onClick: React.MouseEventHandler<HTMLButtonElement>
  label?: string
  children?: React.ReactNode
  tertiaryButtonClassName?: string
  isDisabled?: boolean
  isActive?: boolean
}

export const TertiaryButton = ({
  testLocator,
  onClick,
  label,
  tertiaryButtonClassName,
  isDisabled,
  isActive,
  children
}: TertiaryButtonProps) => {
  return (
    <button
      test-locator={testLocator}
      className={`bg-[#F0F4F7] ${isActive ? 'bg-[#EBF2F2]' : ''} text-[#232323] rounded-[12px] h-[48px] w-full border border-solid border-[#EBF2F2]
        focus:outline-none hover:border-[#EBF2F2] font-[500] text-[14px] text-center disabled:opacity-20 ${tertiaryButtonClassName ?? ''}`}
      onClick={onClick}
      disabled={isDisabled}
    >
      {children ?? label}
    </button>
  )
}
